import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value", "placeholder"]


export default /*#__PURE__*/_defineComponent({
  __name: 'FormControlTextarea',
  props: {
    placeholder: null,
    modelValue: null,
    error: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:model-value', v: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  placeholder?: string;
  modelValue?: string;
  error?: string;
};





const doEmit = (e: Event | InputEvent) => {
  emit(
    "update:model-value",
    (e.target as HTMLTextAreaElement).value
  );
}

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("textarea", {
      class: _normalizeClass(["form-control", { error: __props.error }]),
      value: __props.modelValue,
      placeholder: __props.placeholder,
      onInput: doEmit
    }, null, 42, _hoisted_2),
    _createVNode(_component_Error, { error: __props.error }, null, 8, ["error"])
  ]))
}
}

})